export const FormItemDescription: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={"cpln-ant-form-item-description"}>{children}</div>;
};
